import { DayPickerProps, Labels } from 'react-day-picker';
import { AnyState, EventObject } from 'xstate';

import { Interval, Locale } from 'date-fns';
import { FormatRangeFunction } from './utils';

export type DayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export enum StateTarget {
  NoDatesSelected = 'no-dates-selected',
  OneDateSelected = 'one-date-selected',
  TwoDatesSelected = 'two-dates-selected',
  WeekSelected = 'week-selected',
}

export enum DateTimePickerMode {
  Range = 'range',
  Single = 'single',
}

export enum DayRendererModifiers {
  RangeStart = 'range-start',
  RangeEnd = 'range-end',
  InTheMiddle = 'in-the-middle',
}

export interface MachineContext {
  range: Interval;

  rangeMaxDays?: number;
  limit: Partial<Interval>;
}

export interface MachineEvent extends EventObject {
  date?: Date;
  range?: Interval;
  hours?: number;
  minutes?: number;
  seconds?: number;
}

export interface OnChangeProps {
  date?: Date;
  range: Interval;
  state: AnyState;
}

export interface PickerProps
  extends Pick<
    DayPickerProps,
    | 'disabled'
    | 'fixedWeeks'
    | 'showWeekNumber'
    | 'numberOfMonths'
    | 'modifiers'
    | 'showOutsideDays'
    | 'selected'
    | 'onWeekNumberClick'
    | 'onDayClick'
  > {
  mode?: 'single' | 'range';
  locale: Locale;
  startOfWeek: DayOfWeek;
  labels?: Partial<Labels>;
  dateOnly?: boolean;
  minutesStep?: number;
  rangeMaxDays?: number;
  onChange?: (props: OnChangeProps) => void;
}

export interface FormatterProps {
  patterns: {
    connector: string;
    date: string;
    time: string;
  };
  dateOnly?: boolean;
}

export interface FormatRangeOptions extends FormatterProps {
  formatter: (props: FormatterProps) => FormatRangeFunction;
}

export interface FloorDateOptions {
  hoursStep?: number;
  minutesStep?: null | number;
  secondsStep?: null | number;
}
